import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { CookieWrapper, Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphPodcast = ({ entity }) => {
  const embedUrl = entity.getIn(['field_podcast_url', 0, 'value'], '');
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <Container>
      <CookieWrapper url={embedUrl}>
        <Fade triggerOnce bottom distance="50px" duration={500} className="Paragraph">
          <div id={paragraphKey} className="ParagraphPodcast">
            <div>
              {embedUrl && (
                <iframe src="https://embed.acast.com/5f6b31d8ec12ab59b7a48345?feed=true" />
              )}
            </div>
          </div>
        </Fade>
      </CookieWrapper>
    </Container>
  );
};

export default ParagraphPodcast;
